import { render, staticRenderFns } from "./BasketProductInfo.vue?vue&type=template&id=336d85eb&scoped=true&"
import script from "./BasketProductInfo.vue?vue&type=script&lang=js&"
export * from "./BasketProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasketProductInfo.vue?vue&type=style&index=0&id=336d85eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d85eb",
  null
  
)

export default component.exports